import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from "react-router-dom";
import { Formik, Field, Form as FormikForm } from 'formik';
import { Icon } from 'semantic-ui-react';
import { requestLogin } from '../data/action';
import { loginSchema } from '../data/model'
import logo from "../../app/logo1.png";
import { history } from '../../../configureStore'
import './loginForm.css';


const InputRow = ({ name, type = 'text', placeholder, icon, autoFocus, id, required }) => (
    <Field
        name={name}
        render={({ field, form }) => {
            const error = form.errors && form.errors[name]
            const touched = form.touched && form.touched[name]
            return (
                <div className="login-field">
                    <label className="login-field-label" htmlFor={id || name}>
                        {required && <span className="login-field-required">*</span>}
                        {placeholder}
                    </label>
                    <div className="login-input-row">
                        <input
                            {...field}
                            value={field.value || ''}
                            id={id || name}
                            type={type}
                            placeholder={placeholder}
                            autoFocus={autoFocus}
                            autoComplete={type === 'password' ? 'current-password' : 'off'}
                        />
                        <Icon name={icon} className="login-icon" />
                    </div>
                    {touched && error && (
                        <div className="login-field-error">{error}</div>
                    )}
                </div>
            )
        }}
    />
)


const LoginForm = (props) => {
    const loginStage = useSelector(state => state.login.params.loginStage)
    const successfulLogin = useSelector(state => state.login.params.successfulLogin)
    const errorMessage = useSelector(state => state.login.params.failureMessage)
    const dispatch = useDispatch()

    const saveLogin = (values) => {
        localStorage.setItem('acc', values.acc);
        dispatch(requestLogin(values))
    }

    const approverId = document.getElementById("userName") ? document.getElementById("userName").value : "";

    useEffect(() => {
        if (successfulLogin)
            history.push({ pathname: "/txnsync/list", approverId })
    }, [successfulLogin]);

    const isAuthenticated = localStorage.getItem('user')
    const isValid = localStorage.getItem('exp') > new Date().getTime() / 1000

    if (isAuthenticated && isValid) {
        return (
            <Redirect
                to={{
                    pathname: "/txnsync/list",
                    state: { from: props.location },
                    approverId
                }}
            />
        )
    }

    return (
        <div className="login-page">
            <div className="login-brand">
                <div className="login-brand-content">
                    <img src={logo} alt="RealBooks" />
                    <h1 className="login-brand-title">RealBooks</h1>
                    <p className="login-brand-tagline">
                        Business Intelligence Redefined.<br />
                        Maruti DMS Integration
                    </p>
                </div>
            </div>

            <div className="login-side">
                <div className="login-form-wrap">
                    <p className="login-form-sub">Sign in to your account</p>

                    <Formik
                        validationSchema={loginSchema}
                        initialValues={{ acc: '', user: '', password: '' }}
                        onSubmit={(values) => saveLogin(values)}
                    >
                        {({ handleSubmit }) => (
                            <FormikForm onSubmit={handleSubmit}>
                                <InputRow
                                    name="acc"
                                    id="acc"
                                    placeholder="Account Name"
                                    icon="building outline"
                                    autoFocus
                                    required
                                />
                                <InputRow
                                    name="user"
                                    id="userName"
                                    placeholder="Username"
                                    icon="user outline"
                                    required
                                />
                                <InputRow
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    icon="lock"
                                    required
                                />

                                <button type="submit" className="login-submit">
                                    Sign In
                                    <Icon name="arrow right" style={{ margin: 0 }} />
                                </button>

                                {loginStage === 'error' && errorMessage && (
                                    <div className="login-error">
                                        {errorMessage.error_message || 'Invalid credentials. Please try again.'}
                                    </div>
                                )}
                            </FormikForm>
                        )}
                    </Formik>

                    <div className="login-footer">
                        © {new Date().getFullYear()} RealBooks · All rights reserved
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginForm;
